// ✅ Updated SignoutButton.jsx (Theme-based styling)
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { LogOut } from 'lucide-react';
import { useAuth0 } from "@auth0/auth0-react";
import { useTheme } from '../../Theme/ThemeContext';

const SignoutButton = ({ redirectTo = '/signin', variant = 'default', showText = false, iconSize = 4 }) => {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['authtoken', 'refresh_token']);
  const { logout } = useAuth0();
  const { theme } = useTheme();

  const handleSignout = () => {
    const domain = window.location.hostname;

    // ✅ Remove cookies properly
    removeCookie('authtoken', { path: '/', domain });
    removeCookie('refresh_token', { path: '/auth/refresh', domain });

    // ✅ Clear storage completely
    localStorage.clear();
    sessionStorage.clear();

    // ✅ Logout from Auth0 (CRITICAL FIX)
    // logout({
    //   logoutParams: {
    //     returnTo: window.location.origin
    //   }
    // });
  };

  // Different styles based on variant
  const getButtonStyles = () => {
    switch (variant) {
      case 'icon-only':
        return {
          padding: '8px',
          borderRadius: '8px',
          background: 'transparent',
          border: `1px solid ${theme.border}`,
          transition: 'all 0.2s',
        };
      case 'full':
        return {
          padding: '8px 16px',
          borderRadius: '8px',
          background: `${theme.danger || '#ef4444'}10`,
          border: `1px solid ${theme.danger || '#ef4444'}30`,
          transition: 'all 0.2s',
        };
      default:
        return {
          padding: showText ? '8px 16px' : '8px',
          borderRadius: '8px',
          background: 'transparent',
          border: `1px solid ${theme.border}`,
          transition: 'all 0.2s',
        };
    }
  };

  const buttonStyles = getButtonStyles();

  return (
    <button
      onClick={handleSignout}
      className={`flex items-center gap-2 rounded-lg transition-all`}
      style={{
        ...buttonStyles,
        color: variant === 'full' ? (theme.danger || '#ef4444') : theme.textSecondary,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
      onMouseEnter={(e) => {
        if (variant === 'full') {
          e.currentTarget.style.background = theme.danger || '#ef4444';
          e.currentTarget.style.color = '#ffffff';
          e.currentTarget.style.borderColor = theme.danger || '#ef4444';
        } else {
          e.currentTarget.style.background = `${theme.hover}20`;
          e.currentTarget.style.color = theme.accent1;
          e.currentTarget.style.borderColor = theme.accent1;
        }
      }}
      onMouseLeave={(e) => {
        if (variant === 'full') {
          e.currentTarget.style.background = `${theme.danger || '#ef4444'}10`;
          e.currentTarget.style.color = theme.danger || '#ef4444';
          e.currentTarget.style.borderColor = `${theme.danger || '#ef4444'}30`;
        } else {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = theme.textSecondary;
          e.currentTarget.style.borderColor = theme.border;
        }
      }}
    >
      <LogOut className={`w-${iconSize} h-${iconSize}`} />
    </button>
  );
};

export default SignoutButton;